import React, { useEffect, useMemo } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { toast } from 'react-toastify';
import { toastOption } from '../../../../_metronic/_helpers';
import { CheckerRequestForm } from './CheckerRequestForm';
import { CheckerRequestDialogHeader } from './CheckerRequestDialogHeader';
import * as actions from '../_redux/checkerAction';
import { useCheckerUIContext } from '../CheckerUIContext';
import { CheckerRequestDialogList } from './CheckerRequestDialogList';

export const CheckerRequestDialog = ( { settle_batch_uuid, show, onHide, status_checker } ) => {
	const checkerUIContext = useCheckerUIContext();
	const checkerUIProps = useMemo( () => {
		return {
			queryParams: checkerUIContext.queryParams,
		}
	}, [ checkerUIContext ] )

	const dispatch = useDispatch();


	// FUNGSI UPLOAD FORM DARI CHECKER REQUEST FORM
	const saveChecker = ( checker ) => {
		if ( checker.status_checker === 'SETTLE' ) {
			checker.reason = '';
		}
		checker.settle_batch_uuid = settle_batch_uuid
		dispatch( actions.updateStatusChecker( checker ) ).then( ( response ) => {
			toast.success( response.message, toastOption );
			dispatch( actions.fetchCheckers( checkerUIProps.queryParams ) ).then( () => onHide() );
		} );
	};

	const { currentState } = useSelector(
		( state ) => ({ currentState: state.checkers }),
		shallowEqual,
	);

	const { checkerDetail } = currentState

	useEffect( () => {
		// DATA UNTUK TAMPIL DI REQUEST FORM untuk tabel
		dispatch( actions.fetchCheckerDetail( settle_batch_uuid, status_checker ) )
	}, [ settle_batch_uuid, status_checker, dispatch ] );

	return (
		<Modal
			aria-labelledby="example-modal-sizes-title-lg"
			show={ show }
			onHide={ onHide }
		>
			<CheckerRequestDialogHeader/>
			<CheckerRequestDialogList
				checker={ checkerDetail || [] }
			/>

			{ (status_checker && status_checker !== 'SETTLE') && (
				<CheckerRequestForm
					saveChecker={ saveChecker }
					onHide={ onHide }
				/>
			) }

		</Modal>
	);
};
